// extracted by mini-css-extract-plugin
export default {"root":"SubmitTranslation_root__zLq1T","button":"SubmitTranslation_button__uQzh+"};